import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { validateProperty, validate } from "../../Common"
import { PageHeader } from '../../../Common';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { mobileMenuSchemaObject }  from '../MobileMenuSchema';
import authService from '../../Common/services';

const screenCode = 'MOBILEMENU';

export function MenuAddEdit(props){

    const useStyles = makeStyles((theme) => ({
        root: {
            '& > *': {
                margin: theme.spacing(1),
                width: '25ch',
            },
        },
    }));
    const classes = useStyles();
    const {data, edit} = props.location
    const [title, setTitle] = useState("Add Mobile Menu")
    const [buttonName, setButtonName] = useState("Save")
    const [isChanged, setIsChanged] = useState(0)
    const [menu, setmenu] = useState({
        menuCode: '',
        menuName: '',
        isActive: true
    });
    const [errors, setErrors] = useState({})
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    })
    
    const schema = Joi.object(mobileMenuSchemaObject).options({allowUnknown: true})

    useEffect(() => {
        if (data && edit) {
            setTitle("Edit Menu")
            setmenu(data)
            setButtonName("Update")
        } else {
            setTitle("Add Menu")
        }
    }, [])

    useEffect(() => {
        setIsChanged(isChanged + 1);
    }, [menu]);

    useEffect(() => {
        getPermissions();
    }, []);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITMOBILEMENU');

        if(isAuthorized === undefined){
            props.history.push('/unauthorized');
        }
        
        if (data && edit) {
            setTitle("Edit Mobile Menu ");
            setmenu(data);
            setButtonName("Update");
        } else {
            setTitle("Add Mobile Menu ");
        }
    }

    function handleChange(e){
        const target = e.target

        if(target.name === "menuCode") {
            if(target.value.length === 3) return false
        }

        const value = target.name === 'isActive' ? target.checked: target.value
        
         const error = {...errors}
         const errorMessage = validateProperty(target, mobileMenuSchemaObject)
         errorMessage ? error[target.name] = errorMessage : delete error[target.name]
        
        setmenu({
            ...menu,
            [e.target.name]: value
        })
        setErrors(error)
    }

    async function handleSave(e){
        e.preventDefault()

        const errorMessages = validate(schema, menu)
        errorMessages !== null ?  setErrors(errorMessages) : setErrors({})
        if(errorMessages) return

        if(!edit) {
            const response = await services.saveMenu(menu)
            setMessageModel({...messageModel, hidden: false, type: response.statusCode, disciption: response.message})
            afterSuccessfulyChanged(response.statusCode)
        }
        if(edit) {
            const response = await services.editData(menu)
            setMessageModel({...messageModel, hidden: false, type: response.statusCode, disciption: response.message})
            afterSuccessfulyChanged(response.statusCode)
        }
    }

    function afterSuccessfulyChanged(response) {
        if(response === "Success") {
            clearState()
            setTimeout(() => {
                props.history.push({pathname: '/MobileMenu'})
            }, 1500);
        }
    }

    function clearState() {
        setmenu({...menu,
            menuCode: '',
            menuName: '',
            isActive: true
        })
    }

    function onCancelClick() {
        clearState();
        setErrors({});
    }

    function modalDismissHandler() {
        setMessageModel({...messageModel, hidden: true})
    }

    return (
        <Fragment>
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title={title}
                            isButtonEnable={true}
                            buttonText="Back to Listing"
                            path="/MobileMenu"
                        />

                        <form onSubmit={(e) => handleSave(e)}>
                        <div className="card-body">
                          
                    
                                <div className="form-group row">
                                    <div className="col-md-4">
                                       
                                        <TextField fullWidth label="Menu Code *" 
                                            name="menuCode"
                                            id="menuCode"
                                            value={menu.menuCode}
                                            type="number"
                                            maxLength="2"
                                            onChange={(e) => handleChange(e)}/>
                                        {errors["menuCode"] && <span id="errbranchCode" className="text text-danger">{errors["menuCode"]}</span>}
                                    </div>
                                    <div className="col-md-4">
                                       
                                        <TextField fullWidth label="Menu Name "
                                            name="menuName"
                                            id="menuName"
                                            value={menu.menuName}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["menuName"] && <span id="errbranchCode" className="text text-danger">{errors["menuName"]}</span>}
                                    </div>
                                </div>

                               <br/>
                                <label htmlFor="switch1" >Active</label>

                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                    <input
                                        className="mr-2"
                                        id="isActive"
                                        switch="none"
                                        type="checkbox" 
                                        name="isActive"
                                        onChange={(e) => handleChange(e)}
                                        checked={menu.isActive}
                                    />
                                        <label htmlFor="isActive" data-on-label="Yes"
                                            data-off-label="No"></label>
                                    </div>
                                </div>
                               
                                
                          

                        </div>

                        <div className="card-footer">
                                <input
                                     disabled={validate(schema, menu)} 
                                    type="submit" 
                                    className="btn btn-primary" 
                                    value={buttonName} 
                                />
                                <input

                                    type="reset"
                                    className="btn btn-warning pull-right"
                                    value="Clear"
                                    onClick={onCancelClick}
                                />
                            </div>
                              </form>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}